import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import {
  getGochiMenus,
  getGochiMenuDetail,
  deleteGochiMenu,
  showHideGochiMenu,
  changeShashokuOption,
  addMenuEvent,
  deleteMenuEvent
} from '../../actions/GochiMenus';
import { sendLogin } from '../../auth/Auth';
import ContentDialog from '../../components/molecules/ContentDialog';
import SupplyGochiGroupBody from '../../components/molecules/SupplyGochiGroupBody';
import SupplyGochiGroupHead from '../../components/molecules/SupplyGochiGroupHead';
import ExPaginationGroup from '../../components/molecules/ExPaginationGroup';

const styles = {
  scrollTable: {
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      ticket: state.ticketsGroup.list.budgetGochis,
      totalCount: state.ticketsGroup.list.totalCount,
      offset: state.ticketsGroup.list.offset
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiMenus,
          getGochiMenuDetail,
          deleteGochiMenu,
          showHideGochiMenu,
          changeShashokuOption,
          addMenuEvent,
          deleteMenuEvent
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDetailModal', 'updateOpenDetailModal', false),

  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openDelete', 'updateOpenDelete', false),
  withState('openDeleteProgress', 'updateOpenDeleteProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isDeleteSuccess', 'updateIsDeleteSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('rowsPerPage', 'setRowsPerPage', 15),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withState('page', 'setPage', 0),
  withState('shashokuOption', 'setShashokuOption', 0),
  withState('openFullMessage', 'updateOpenFullMessage', false),
  withState('fullMessage', 'setFullMessage', ''),
  withState('message', 'setMessage', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    roles,
    page,
    selectedPage,
    handleChangePage,
    ticket,
    totalCount,
    updateOpenDetailModal,
    updateOpenDelete,
    rowsPerPage,
    setTargetRowId,
    openDeleteProgress,
    updateOpenDeleteProgress,
    loading,
    isDeleteSuccess,
    resultMessage,
    order,
    orderBy,
    handleRequestSort,
    shashokuOption,
    setShashokuOption,
    openFullMessage,
    updateOpenFullMessage,
    fullMessage,
    message,
    setMessage,
    setRowsPerPage
  }) => {
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);

    const progressOkAction = () => {
      if (isDeleteSuccess) {
        updateOpenDelete(false);
        updateOpenDeleteProgress(false);
      } else {
        updateOpenDeleteProgress(false);
      }
    };

    return (
      <div>
        <ExPaginationGroup
          count={
            totalCount % rowsPerPage > 0
              ? Math.floor(totalCount / rowsPerPage) + 1
              : Math.floor(totalCount / rowsPerPage)
          }
          selectedPage={selectedPage}
          handleChangePage={handleChangePage}
          limit={rowsPerPage}
          totalCount={totalCount}
          setLimit={setRowsPerPage}
          hideRowsPerPage
        />
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <SupplyGochiGroupHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              roles={roles}
            />
            <SupplyGochiGroupBody
              ticket={ticket}
              emptyRows={emptyRows}
              page={page}
              rowsPerPage={rowsPerPage}
              updateOpenDetailModal={updateOpenDetailModal}
              setTargetRowId={setTargetRowId}
              roles={roles}
              order={order}
              orderBy={orderBy}
              shashokuOption={shashokuOption}
              setShashokuOption={setShashokuOption}
              message={message}
              setMessage={setMessage}
            />
          </Table>
        </div>
        <div>
          <ExPaginationGroup
            count={
              totalCount % rowsPerPage > 0
                ? Math.floor(totalCount / rowsPerPage) + 1
                : Math.floor(totalCount / rowsPerPage)
            }
            selectedPage={selectedPage}
            handleChangePage={handleChangePage}
            limit={rowsPerPage}
            totalCount={totalCount}
            hideRowsPerPage
          />
        </div>
        <ProgressDialog
          openProgress={openDeleteProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
        <ContentDialog
          openContent={openFullMessage}
          updateOpenContent={updateOpenFullMessage}
          content={fullMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
